import ListingBase from './ListingBase.js';
/**
 * Listing component
 */
export default class Listing extends ListingBase {
  /**
   * Mounted
   */
  mounted() {
    this.setup();
  }

  /**
   * Setup on content change
   */
  onAfterContent() {
    this.setup();
  }

  /**
   * Reset filters
   */
  onListingPanelReset() {
    super.onListingPanelReset();
  }

  /**
   * Trigger fields change on panel close
   */
  onListingPanelClose() {
    this.onFieldsChange();
  }
}
